<template>
    <vx-tabbed-router
        :tabs="localTabs"
        v-on="listeners"
        :position="position"
        class="tabbed-router"
    />
</template>

<script>
/* Example Tab
{
    icon: 'icon-activity',
    label: `Active`,
    filter: 'InProgress',
    disabled: false,
    class: 'bg-primary'
}
*/

export default {
    name: 'vx-tabbed-query-router',
    props: {
        value: {
            type: String
        },
        queryParam: {
            type: String,
            required: true,
            default: 'status'
        },
        filterKey: {
            type: [String, Function],
            default: 'filter'
        },
        tabs: {
            type: Array,
            default: () => [],
            validator: (t) => t && t.any(),
            required: true
        },
        position: {
            type: String,
            default: 'top'
        }
    },
    watch: {
        filter_x: {
            handler(newV, oldV) {
                if (newV != oldV) {
                    this.$emit('input', newV)
                }
            },
            immediate: true
        }
    },
    computed: {
        getFilter() {
            if (typeof this.filterKey === 'function') {
                return this.filterKey
            }
            return (tab) => tab && tab[this.filterKey]
        },
        routeName() {
            return this.$route.name
        },
        localTabs() {
            return this.tabs.map((tab) => {
                return {
                    ...tab,
                    route: {
                        name: this.routeName,
                        query: {
                            [this.queryParam]: this.getFilter(tab)
                        }
                    }
                }
            })
        },
        filter_x() {
            return this.$route.query[this.queryParam]
        },
        listeners() {
            var result = { ...this.$listeners }
            delete result.input
            return result
        }
    },
    methods: {
        getTabByFilter(filter) {
            return this.localTabs.find((t) => this.getFilter(t) == filter)
        }
    }
}
</script>

<style lang="scss" scoped>
.tabbed-router {
    ::v-deep .route-container {
        display: none;
    }
}
</style>
